import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function PipIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g fill={color}>
        <path d="m21.5365 4.65359c.355-.03257.6633.24643.6633.60293v7.24748c-.1378-.0241-.2807-.0325-.4266-.0194-.2118.0191-.529.045-.9234.0727v-6.48984c-1.8492.15331-5.2125.38261-8.85.38261-3.63749 0-7.00083-.2293-8.85-.38261v10.05294c1.643-.1438 4.52079-.3429 8.1-.368v1.3506c-4.21723.0298-7.44428.3029-8.7791.4359-.33598.0335-.63181-.2115-.66738-.539l-.00352-.0662v-11.67718c0-.3565.30828-.6355.66329-.60293 1.49672.13729 5.33511.44648 9.53671.44648s8.04-.30919 9.5367-.44648z" />
        <path d="m12.5998 14.1068c0-.164.1419-.2924.3053-.2777.6994.0629 2.511.2064 4.4947.2064s3.7953-.1435 4.4947-.2064c.1634-.0147.3053.1137.3053.2777v5.3801c0 .1655-.1433.2948-.3081.2789-.6597-.064-2.3268-.2012-4.4919-.2012-2.1648 0-3.8317.1384-4.4916.203-.1649.0161-.3084-.1132-.3084-.2789z" />
      </g>
    </SVGWrapper>
  );
}

export default PipIcon;
